import _ from 'lodash';

export const sendAuthTokenAndSubdomainToWatch = _.noop;

export const sendUserLevelToWatch = _.noop;
